import { render } from "./Indecision.vue?vue&type=template&id=1907e9e8&scoped=true"
import script from "./Indecision.vue?vue&type=script&lang=js"
export * from "./Indecision.vue?vue&type=script&lang=js"

import "./Indecision.vue?vue&type=style&index=0&id=1907e9e8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1907e9e8"

export default script